export default () => import(/* webpackChunkName: 'coffee/app/agreement/lkcard-auto-renew' */ './LkcardAutoRenew');
